import { CLEAN_STATE } from '../sagas/actions';

export const SET_DATA_FILTER = 'SET_DATA_FILTER';
export const SET_NEXT_PAGE = 'SET_NEXT_PAGE';
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';
export const FILTER_OPTIONS_FAILURE = 'FILTER_OPTIONS_FAILURE';
export const SET_FILTER_LOADING = 'SET_FILTER_LOADING';
export const UPDATE_CUSTOMER_FIELD = 'UPDATE_CUSTOMER_FIELD';
export const CLEAN_FILTER_DATA = 'CLEAN_FILTER_DATA';
export const SET_ORGANIZATIONS_NAMES = 'SET_ORGANIZATIONS_NAMES';
export const SET_SELECTED_ORGANIZATIONS_NAMES = 'SET_SELECTED_ORGANIZATIONS_NAMES';

const initialState = {
  pageNumber: 0,
  customer: 'FEMSA',
  dateStart: null,
  dateEnd: null,
  order: 'ASC',
  orderByField: '',
  organizationsNames: [],
  problemsTypes: null,
  serial: '',
  vehicleCode: '',
  options: {
    organizationsNames: [],
    customers: [],
    problemsTypes: [],
    error: null,
    loading: false
  }
};

const problemsFilterReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_DATA_FILTER: {
      return { ...state, ...payload, options: { ...state.options } };
    }
    case SET_NEXT_PAGE: {
      return { ...state, pageNumber: state.pageNumber + 1 };
    }
    case SET_FILTER_OPTIONS: {
      return { ...state, options: { customers: payload.customers, problemsTypes: payload.problemsTypes, error: null } };
    }
    case FILTER_OPTIONS_FAILURE: {
      return { ...state, options: { ...state.options, error: payload } };
    }
    case UPDATE_CUSTOMER_FIELD: {
      return { ...state, customer: payload };
    }
    case SET_FILTER_LOADING: {
      return { ...state, options: { ...state.options, loading: payload } };
    }
    case SET_ORGANIZATIONS_NAMES: {
      return { ...state, options: { ...state.options, organizationsNames: payload.map(organization => organization.name) } };
    }
    case SET_SELECTED_ORGANIZATIONS_NAMES: {
      return { ...state, organizationsNames: payload };
    }
    case CLEAN_STATE: {
      return { ...initialState };
    }
    case CLEAN_FILTER_DATA: {
      return { ...initialState, options: { ...state.options } };
    }
    default:
      return state;
  }
}

export default problemsFilterReducer;


// WEBPACK FOOTER //
// ./src/reducers/filters.js